import { type MCPServerInfo } from '../../types';

const NewRelicServer: MCPServerInfo = {
  serverId: 'NEW_RELIC',
  name: 'New Relic',
  slug: 'new-relic',
  description:
    'New Relic MCP Server - Access and analyze your observability data including entities, NRQL queries, alerts, and performance analytics using natural language.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.newrelic.com/mcp/'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default NewRelicServer;
